export function unescapeHTML(str) {
  return (str == null ? "" : str)
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'");
}

export function getSlideIndices(): {
  slide: number;
  v: number;
  fragment: number;
} {
  const indices = Reveal.getIndices();
  const fragment = (indices as any).f;
  return {
    slide: indices.h,
    v: indices.v,
    fragment: fragment == null ? -1 : fragment,
  };
}
